import { gql } from '@apollo/client';

export const studentAnsweredAssignmentFragment = gql`
  fragment StudentAnsweredAssignment on StudentAnsweredAssignment {
    id: _id
    name
    maxScore
    timeLimit
    showOnlyTotalScore

    answer {
      startedAt
      finishedAt
      time
      score
    }
    exercises {
      id: _id
      text
      type
      code
      explanation
      media
      questions
    }
  }
`;

export const studentAssignment = gql`
  fragment StudentAssignment on StudentAssignment {
    id: _id
    name
    maxScore
    expired
    expirationDate
    answered
    timeLimit
    answer {
      _id
      score
      time
      startedAt
      finishedAt
    }
  }
`;
